import { render, staticRenderFns } from "./IntegralGoodList.vue?vue&type=template&id=88b79f84&scoped=true&"
import script from "./IntegralGoodList.vue?vue&type=script&lang=js&"
export * from "./IntegralGoodList.vue?vue&type=script&lang=js&"
import style0 from "./IntegralGoodList.vue?vue&type=style&index=0&id=88b79f84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b79f84",
  null
  
)

export default component.exports